module.exports = __webpack_public_path__ + "static/p24-bbdf4e5cd09c146c78f8eba20a28fd9a.jpg";